import { Store } from '../../models';
import { loadChatwoot } from './chatwoot';

export const loadWidget = (
    store: Store | null,
    openOnLoad: boolean = false,
    zindex: number = 1
) => {
    const load = (accountId?: number, accountEmail?: string) => {
        loadChatwoot(store, openOnLoad, zindex);
    };

    if (store) {
        store.account.asyncAccount.then(account => {
            load(
                account ? account.id : undefined,
                account ? account.email : undefined
            );
        });
    } else {
        load();
    }
};
